import { render, staticRenderFns } from "./SearchByRfc.vue?vue&type=template&id=48c5235e&"
import script from "./SearchByRfc.vue?vue&type=script&lang=js&"
export * from "./SearchByRfc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports